import { createSlice } from "@reduxjs/toolkit";
import { FetchStatus } from "../../shared/redux.consts";
import {
  LoanDocumentsState,
  LoanDocumentsStore,
} from "../../types/loan-documents";
import { fetchLoanDocuments } from "./loan-documents.thunk";
import { DocumentStage } from "./loan-documents.consts";
import { getUnverifiedDocumentsInStage } from "./loan-documents.utils";

const initialLoanDocumentsState: LoanDocumentsState = {
  status: FetchStatus.IDLE,
  loanDocuments: null,
  loanStages: null,
};

export const loanDocumentsSlice = createSlice({
  name: "loanDocuments",
  initialState: initialLoanDocumentsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoanDocuments.pending, (state) => {
        state.status = FetchStatus.LOADING;
      })
      .addCase(fetchLoanDocuments.fulfilled, (state, action) => {
        if (action.payload) {
          const requiredForAssessmentDocs = getUnverifiedDocumentsInStage(
            action.payload.applicants,
            DocumentStage.ASSESSMENT
          );
          const requiredForApprovalDocs = getUnverifiedDocumentsInStage(
            action.payload.applicants,
            DocumentStage.APPROVAL
          );
          const requiredForSettlementDocs = getUnverifiedDocumentsInStage(
            action.payload.applicants,
            DocumentStage.SETTLEMENT
          );

          state.status = FetchStatus.SUCCESS;
          state.loanDocuments = action.payload;
          state.loanStages = {
            requiredForAssessmentDocs: requiredForAssessmentDocs,
            requiredForApprovalDocs: requiredForApprovalDocs,
            requiredForSettlementDocs: requiredForSettlementDocs,
            hasRequiredForAssessmentDocs: requiredForAssessmentDocs.length > 0,
            hasRequiredForApprovalDocs: requiredForApprovalDocs.length > 0,
            hasRequiredForSettlementDocs: requiredForSettlementDocs.length > 0,
          };
        } else {
          state.status = FetchStatus.FAILED;
          state.error = "loan documents get failed";
        }
      })
      .addCase(fetchLoanDocuments.rejected, (state, action) => {
        state.status = FetchStatus.FAILED;
        if (action.error?.message) {
          state.error = action.error.message;
        }
      });
  },
});

export default loanDocumentsSlice.reducer;

export const selectLoanDocumentsState = (store: LoanDocumentsStore) =>
  store.loanDocumentsState;
